import type { Maybe } from '__generated__/graphql-types';

import type { CollectionListItemFragmentFragment } from 'bundles/enterprise-collections/queries/fragments/__generated__/CollectionListItemFragment';
import type { CollectionListItemSkillsMetaFragmentFragment } from 'bundles/enterprise-collections/queries/fragments/__generated__/CollectionListItemSkillsMetaFragment';
import type { CollectionListItemStruct, Item } from 'bundles/enterprise-legacy-learner-home/types/programCommon';
import type {
  CourseElement,
  S12nElement,
} from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/generateFilterDropdownOptions';

type CollectionListItemFragmentType = Maybe<
  { __typename?: 'ProgramCurriculumCollectionsV1' } & CollectionListItemFragmentFragment
>;
type CollectionListItemSkillsMetaFragmentType = Maybe<
  { __typename?: 'ProgramCurriculumCollectionsV1' } & CollectionListItemSkillsMetaFragmentFragment
>;

type StructDataSource = undefined | CollectionListItemFragmentType | CollectionListItemSkillsMetaFragmentType;

/**
 * TODO remove this check in favor of a simple strict comparison
 * after skill id format becomes consistent across learner/enterprise apis.
 */
export const isSkillIdEqual = (a?: string, b?: string) => a?.split('~')[0] === b?.split('~')[0];

export const convertLearnerDiagnosticIdToBaseSkillId = (a: string) => a.split('~')[1] ?? a;

export const convertTSPSkillIdToBaseSkillId = (a: string) => a.split('~')[0] ?? a;

export const convertVersionedSkillIdToBaseSkillId = (a: string) => a.split('@')[0] ?? a;

export const castToProduct = (element: CourseElement | S12nElement) => {
  // This conversion has been created to more closely reflect our data shape,
  // but also still meet the existing interface of browse utilities.
  const maybeCourseIds: undefined | string[] =
    'courseIds' in element
      ? element.courseIds?.filter((val) => !!val)?.map<string>((cid) => String(cid)) ?? undefined
      : undefined;
  return {
    ...element,
    courseIds: maybeCourseIds,
  };
};

export const castToStruct = (collection: StructDataSource) => {
  const struct: CollectionListItemStruct = {
    ...collection,
    __typename: collection?.__typename,
    id: collection?.id ?? '',
    title: collection?.title ?? '',
    image: collection?.image ?? null,
    collectionTrackingId: collection?.collectionTrackingId ?? '',
    courseIds: collection?.courseIds?.map((v) => String(v)) ?? [],
    s12nIds: collection?.s12nIds?.map((v) => String(v)) ?? [],
    description: collection?.description ?? {
      cml: undefined,
    },
    trackId: collection?.trackId ?? '',
    courses: collection?.courses ?? null,
    // @ts-expect-error Missing field is valid for s12ns
    s12ns: collection?.s12ns ?? null,
    items: collection?.items?.map((v) => v as Item) ?? [],
    collectionContextMetadata: (collection as CollectionListItemSkillsMetaFragmentType)
      ?.collectionContextMetadata as CollectionListItemStruct['collectionContextMetadata'],
    associatedSessions: collection?.associatedSessions,
  };

  return struct;
};

export const redirectTo = (url: string) => {
  window.location.assign(url);
};
